export default __webpack_public_path__ + "static/media/payment-type.b163caa1.svg";